export const DEFAULT_LOCALE = 'en-US';

export const DATE_FNS_LOCALES = [
    'ar',
    'bg',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'en-GB',
    'en-US',
    'eo',
    'es',
    'fi',
    'fil',
    'fr-CH',
    'fr',
    'hr',
    'id',
    'is',
    'it',
    'ja',
    'ko',
    'mk',
    'nb',
    'nl',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sv',
    'th',
    'tr',
    'ua',
    'vi',
    'zh-CN',
    'zh-TW',
];
